import ProductPlanAPI from 'dashboard/api/productPlans';
import { createStore } from 'dashboard/store/storeFactory';

export const useProductPlansStore = createStore({
  name: 'productPlans',
  type: 'pinia',
  API: ProductPlanAPI,
});
